import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_2,
  OPERATOR_TYPES_3,
  OPERATOR_TYPES_6,
} from './operators';

export const AUTOMATIONS = {
  message_created: {
    conditions: [
      {
        key: 'message_type',
        name: 'Message Type',
        attributeI18nKey: 'MESSAGE_TYPE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'content',
        name: 'Message Content',
        attributeI18nKey: 'MESSAGE_CONTAINS',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Conversation Language',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'Add a label',
        attributeI18nKey: 'ADD_LABEL',
      },
      {
        key: 'send_email_to_team',
        name: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'Send an email transcript',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'Mute conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'Snooze conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },

      {
        key: 'resolve_conversation',
        name: 'Resolve conversation',
        attributeI18nKey: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_created: {
    conditions: [
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'Browser Language',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'Country',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'referer',
        name: 'Referrer Link',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Conversation Language',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'Priority',
        attributeI18nKey: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'Assign an agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'Send an email transcript',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'Mute conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'Snooze conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'Resolve conversation',
        attributeI18nKey: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_updated: {
    conditions: [
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'Browser Language',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'Country',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'Referrer Link',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'Assignee',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'Team',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Conversation Language',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'Priority',
        attributeI18nKey: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'Assign an agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'Send an email transcript',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'Mute conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'Snooze conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'Resolve conversation',
        attributeI18nKey: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
    ],
  },
  conversation_opened: {
    conditions: [
      {
        key: 'browser_language',
        name: 'Browser Language',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'Email Subject',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'Country',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'Referrer Link',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'Assignee',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'Phone Number',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'Team',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'Inbox',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Conversation Language',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'Priority',
        attributeI18nKey: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'Assign to agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'Assign a team',
        attributeI18nKey: 'ASSIGN_TEAM',
      },
      {
        key: 'assign_agent',
        name: 'Assign an agent',
        attributeI18nKey: 'ASSIGN_AGENT',
      },
      {
        key: 'send_email_to_team',
        name: 'Send an email to team',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'Send a message',
        attributeI18nKey: 'SEND_MESSAGE',
      },
      {
        key: 'send_email_transcript',
        name: 'Send an email transcript',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'mute_conversation',
        name: 'Mute conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'Snooze conversation',
        attributeI18nKey: 'MUTE_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'Send Webhook Event',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'Send Attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
      },
    ],
  },
};

function updateAutomationCondition(language) {
  if (language === 'fr') {
    AUTOMATIONS.message_created.conditions[0].name = 'Type de message';
    AUTOMATIONS.message_created.conditions[1].name = 'Contenu du message';
    AUTOMATIONS.message_created.conditions[2].name = 'E-mail';
    AUTOMATIONS.message_created.conditions[3].name = 'Boîte de réception';
    AUTOMATIONS.message_created.conditions[4].name = 'Langue de conversation';
    AUTOMATIONS.message_created.conditions[5].name = 'Numéro de téléphone';


    AUTOMATIONS.conversation_created.conditions[0].name = 'Statut';
    AUTOMATIONS.conversation_created.conditions[1].name = 'Langue du navigateur';
    AUTOMATIONS.conversation_created.conditions[2].name = "Objet de l'e-mail";
    AUTOMATIONS.conversation_created.conditions[3].name = 'Pays';
    AUTOMATIONS.conversation_created.conditions[4].name = 'Numéro de téléphone';
    AUTOMATIONS.conversation_created.conditions[5].name = 'Lien de référence';
    AUTOMATIONS.conversation_created.conditions[6].name = 'E-mail';
    AUTOMATIONS.conversation_created.conditions[7].name = 'Boîte de réception';
    AUTOMATIONS.conversation_created.conditions[8].name = 'Langue de conversation';

    AUTOMATIONS.conversation_updated.conditions[0].name = 'Statut';
    AUTOMATIONS.conversation_updated.conditions[1].name = 'Langue du navigateur';
    AUTOMATIONS.conversation_updated.conditions[2].name = "Objet de l'e-mail";
    AUTOMATIONS.conversation_updated.conditions[3].name = 'Pays';
    AUTOMATIONS.conversation_updated.conditions[4].name = 'Lien de référence';
    AUTOMATIONS.conversation_updated.conditions[5].name = 'Numéro de téléphone';
    AUTOMATIONS.conversation_updated.conditions[6].name = 'Destinataire';
    AUTOMATIONS.conversation_updated.conditions[7].name = 'Équipe';
    AUTOMATIONS.conversation_updated.conditions[8].name = 'E-mail';
    AUTOMATIONS.conversation_updated.conditions[9].name = 'Boîte de réception';
    AUTOMATIONS.conversation_updated.conditions[10].name = 'Langue de conversation';

    AUTOMATIONS.conversation_opened.conditions[10].name = 'Langue du navigateur';
    AUTOMATIONS.conversation_opened.conditions[10].name = 'E-mail';
    AUTOMATIONS.conversation_opened.conditions[10].name = "Objet de l'e-mail";
    AUTOMATIONS.conversation_opened.conditions[10].name = 'Pays';
    AUTOMATIONS.conversation_opened.conditions[10].name = 'Lien de référence';
    AUTOMATIONS.conversation_opened.conditions[10].name = 'Destinataire';
    AUTOMATIONS.conversation_opened.conditions[10].name = 'Numéro de téléphone';
    AUTOMATIONS.conversation_opened.conditions[10].name = 'Équipe';
    AUTOMATIONS.conversation_opened.conditions[10].name = 'Boîte de réception';
    AUTOMATIONS.conversation_opened.conditions[10].name = 'Langue de conversation';
  }
  else {
    AUTOMATIONS.message_created.conditions[0].name = 'Message Type';
    AUTOMATIONS.message_created.conditions[1].name = 'Message Content';
    AUTOMATIONS.message_created.conditions[2].name = 'Email';
    AUTOMATIONS.message_created.conditions[3].name = 'Inbox';
    AUTOMATIONS.message_created.conditions[4].name = 'Conversation Language';
    AUTOMATIONS.message_created.conditions[5].name = 'Phone Number';


    AUTOMATIONS.conversation_created.conditions[0].name = 'Status';
    AUTOMATIONS.conversation_created.conditions[1].name = 'Browser Language';
    AUTOMATIONS.conversation_created.conditions[2].name = "Email Subject";
    AUTOMATIONS.conversation_created.conditions[3].name = 'Country';
    AUTOMATIONS.conversation_created.conditions[4].name = 'Phone Number';
    AUTOMATIONS.conversation_created.conditions[5].name = 'Referrer Link';
    AUTOMATIONS.conversation_created.conditions[6].name = 'Email';
    AUTOMATIONS.conversation_created.conditions[7].name = 'Inbox';
    AUTOMATIONS.conversation_created.conditions[8].name = 'Conversation Language';

    AUTOMATIONS.conversation_updated.conditions[0].name = 'Status';
    AUTOMATIONS.conversation_updated.conditions[1].name = 'Browser Language';
    AUTOMATIONS.conversation_updated.conditions[2].name = "Email Subject";
    AUTOMATIONS.conversation_updated.conditions[3].name = 'Country';
    AUTOMATIONS.conversation_updated.conditions[4].name = 'Referrer Link';
    AUTOMATIONS.conversation_updated.conditions[5].name = 'Phone Number';
    AUTOMATIONS.conversation_updated.conditions[6].name = 'Assignee';
    AUTOMATIONS.conversation_updated.conditions[7].name = 'Team';
    AUTOMATIONS.conversation_updated.conditions[8].name = 'Email';
    AUTOMATIONS.conversation_updated.conditions[9].name = 'Inbox';
    AUTOMATIONS.conversation_updated.conditions[10].name = 'Conversation Language';

    AUTOMATIONS.conversation_opened.conditions[0].name = 'Browser Language';
    AUTOMATIONS.conversation_opened.conditions[1].name = 'Email';
    AUTOMATIONS.conversation_opened.conditions[2].name = "Email Subject";
    AUTOMATIONS.conversation_opened.conditions[3].name = 'Country';
    AUTOMATIONS.conversation_opened.conditions[4].name = 'Referrer Link';
    AUTOMATIONS.conversation_opened.conditions[5].name = 'Assignee';
    AUTOMATIONS.conversation_opened.conditions[6].name = 'Phone Number';
    AUTOMATIONS.conversation_opened.conditions[7].name = 'Team';
    AUTOMATIONS.conversation_opened.conditions[8].name = 'Inbox';
    AUTOMATIONS.conversation_opened.conditions[9].name = 'Conversation Language';
  }
}

export const AUTOMATION_RULE_EVENTS = [
  {
    key: 'conversation_created',
    value: 'Conversation Created',
  },
  {
    key: 'conversation_updated',
    value: 'Conversation Updated',
  },
  {
    key: 'message_created',
    value: 'Message Created',
  },
  {
    key: 'conversation_opened',
    value: 'Conversation Opened',
  },
];

export function updateOptionForAutomationEvent(language) {
  if (language === 'fr') {
    AUTOMATION_RULE_EVENTS[0].value = 'Conversation créée';
    AUTOMATION_RULE_EVENTS[1].value = 'Conversation actualisée';
    AUTOMATION_RULE_EVENTS[2].value = 'Message créé';
    AUTOMATION_RULE_EVENTS[3].value = 'Conversation ouverte';
    updateAutomationCondition(language);
  }
  else {
    AUTOMATION_RULE_EVENTS[0].value = 'Conversation created';
    AUTOMATION_RULE_EVENTS[1].value = 'Conversation updated';
    AUTOMATION_RULE_EVENTS[2].value = 'Message created';
    AUTOMATION_RULE_EVENTS[3].value = 'Conversation opened';
    updateAutomationCondition(language);
  }
}

export const AUTOMATION_ACTION_TYPES = [
  {
    key: 'assign_agent',
    label: 'Assign to agent',
    inputType: 'search_select',
  },
  {
    key: 'assign_team',
    label: 'Assign a team',
    inputType: 'search_select',
  },
  {
    key: 'add_label',
    label: 'Add a label',
    inputType: 'multi_select',
  },
  {
    key: 'send_email_to_team',
    label: 'Send an email to team',
    inputType: 'team_message',
  },
  {
    key: 'send_email_transcript',
    label: 'Send an email transcript',
    inputType: 'email',
  },
  {
    key: 'mute_conversation',
    label: 'Mute conversation',
    inputType: null,
  },
  {
    key: 'snooze_conversation',
    label: 'Snooze conversation',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'Resolve conversation',
    inputType: null,
  },
  {
    key: 'send_webhook_event',
    label: 'Send Webhook Event',
    inputType: 'url',
  },
  {
    key: 'send_attachment',
    label: 'Send Attachment',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'Send a message',
    inputType: 'textarea',
  },
  {
    key: 'change_priority',
    label: 'Change Priority',
    inputType: 'search_select',
  },
];

export function updateOptionForAutomationAction(language) {
  if (language === 'fr') {
    AUTOMATION_ACTION_TYPES[0].label = 'Assigner à un agent' ;
    AUTOMATION_ACTION_TYPES[1].label = 'Assigner une équipe';
    AUTOMATION_ACTION_TYPES[2].label = 'Ajouter une étiquette';
    AUTOMATION_ACTION_TYPES[3].label = "Envoyer un e-mail à l'équipe";
    AUTOMATION_ACTION_TYPES[4].label = 'Envoyer une transcription par courriel';
    AUTOMATION_ACTION_TYPES[5].label = 'Muter la conversation';
    AUTOMATION_ACTION_TYPES[6].label = 'Snooze conversation';
    AUTOMATION_ACTION_TYPES[7].label = 'Résoudre la conversation';
    AUTOMATION_ACTION_TYPES[8].label = 'Envoyer un événement Webhook';
    AUTOMATION_ACTION_TYPES[9].label = 'Envoyer une pièce jointe';
    AUTOMATION_ACTION_TYPES[10].label = 'Envoyer un message';
  }
  else {
    AUTOMATION_ACTION_TYPES[0].label = 'Assign to agent';
    AUTOMATION_ACTION_TYPES[1].label = 'Assign a team';
    AUTOMATION_ACTION_TYPES[2].label = 'Add a label';
    AUTOMATION_ACTION_TYPES[3].label = 'Send an email to team';
    AUTOMATION_ACTION_TYPES[4].label = 'Send an email transcript';
    AUTOMATION_ACTION_TYPES[5].label = 'Mute conversation';
    AUTOMATION_ACTION_TYPES[6].label = 'Snooze conversation';
    AUTOMATION_ACTION_TYPES[7].label = 'Resolve conversation';
    AUTOMATION_ACTION_TYPES[8].label = 'Send Webhook Event';
    AUTOMATION_ACTION_TYPES[9].label = 'Send Attachment';
    AUTOMATION_ACTION_TYPES[10].label = 'Send a message';
  }
}
